import { AbiItem } from 'web3-utils';

export const ERC20_ABI: AbiItem[] = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
    name: 'balanceOf',
    constant: true,
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
  },
];
